import { canAttachDesign } from './content-status'
import type { ContentItem } from '@/types/content'
import { type DesignRun, isDesignRunLive, isDesignRunMade } from '@/types/design'

/** What a post's media shows and offers. */
export interface PostMediaState {
  /** The run to report: the latest one, unless it ended in the attached design; `null` when there is none to report. */
  readonly run: DesignRun | null
  /** The design to open: the attached one; `null` when there is none. */
  readonly openDesignId: string | null
  /** No design is attached and no run is designing one. */
  readonly empty: boolean
  /** The post may still take a design. */
  readonly canAttach: boolean
  /** Raldo can design the media from the post's slides. */
  readonly canDesign: boolean
}

/** The media state of a post from its latest design run (`null` when none ran). */
export function postMediaState(
  post: Pick<ContentItem, 'status' | 'design' | 'media'>,
  latestRun: DesignRun | null,
): PostMediaState {
  const run = post.design || isDesignRunMade(latestRun) ? null : latestRun
  const live = isDesignRunLive(run)
  const canAttach = canAttachDesign(post.status)
  return {
    run,
    openDesignId: post.design?.designId ?? null,
    empty: post.design === null && !live,
    canAttach,
    canDesign: post.media !== null && post.design === null && canAttach && !live,
  }
}
